module.exports = __webpack_public_path__ + "static/media/logo1.bc51ecc7.png";